module.exports = __webpack_public_path__ + "static/media/oneLogo.235d4be0.jpeg";